'use strict';

/* ************* name ***************
// Readme: <trs-login-user></trs-login-user>
// Data: 2016/1/14 14:36:25
*******************************************/
angular.module('util.trsLoginUserModule', []).directive('trsLoginUser', [
    'trsHttpService',
    '$timeout',
    '$state',
    'editingCenterService',
    'messagePublishService',
    '$sessionStorage',
    'globleParamsSet',
    function(trsHttpService, $timeout, $state, editingCenterService, messagePublishService, $sessionStorage, globleParamsSet) {
        return {
            restrict: 'EA',
            scope: {
                img: '=',
                currModule: '=',
            },
            templateUrl: './components/util/trsLoginUser/loginUser_tpl.html',
            // template: '<a class="userName" ui-sref="myzone.personalinfo"><img src="./editingCenter/app/images/user_icon.png" class="edi_usr">{{user}} 欢迎你！</a>',
            link: function($scope, iElement, iAttrs) {
                $timeout(function() {
                    initStatus();
                    getGroup();
                    getUserHeadPic();

                    /**
                     * [initStatus description]初始化状态
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        $scope.status = {
                            curGroupId: '',
                            userHead: '',
                            isShowDropdown: false,
                        };
                        // $scope.status.curGroupId = localStorageService.get('mlfCachedUser').GroupId; // session改变
                        
                        $scope.status.curGroupId = $sessionStorage.get('mlfCachedUser') && $sessionStorage.get('mlfCachedUser').GroupId;
                        watcherLocalStorage();
                        // $rootScope.$on("updateHeadPortrait", function(
                        //     event,
                        //     data
                        // ) {
                        //     getUserHeadPic();
                        // });
                        messagePublishService.subscribe(
                            'headPortrait',
                            function(event, data) {
                                getUserHeadPic();
                            },
                            $scope
                        );
                        messagePublishService.subscribe(
                            'getUserGroup',
                            function(event, data) {
                                getGroup(data);
                            },
                            $scope
                        );
                    }

                    /**
                     * [watcherLocalStorage description] 监控本地存储
                     * @return {[type]} [description]
                     */
                    function watcherLocalStorage() {
                        $scope.$root.$watch('curUserGroup', function(newV) {
                            if (!newV) {
                                return;
                            }
                            $scope.status.curGroupId = newV.GroupId;
                        });
                    }

                    /**
                     * [getGroup description] 获得分组（消息机制带来的好处）
                     * @param   {[obj]}  data  [data description]用户信息
                     * @return  {[null]}       [return description]
                     */
                    function getGroup(data) {
                        // var dataGroup = data ? data : localStorageService.get('mlfCachedUser'); // session改变
                        var dataGroup = data ? data : $sessionStorage.get('mlfCachedUser');
                        $scope.dataUser = [dataGroup];
                        getCurrentLoginUser();
                    }

                    /**
                     * [getUserHeadPic description]获得用户头像
                     * @return {[type]} [description]
                     */
                    function getUserHeadPic() {
                        editingCenterService.getUserHeadPic().then(function(data) {
                            $scope.status.userHead = data;
                        });
                    }
                    $(document).on('click', function (e) {
                        var target = e.target || e.srcElement;
                        var loginImgWrap = document.getElementById('loginImgWrap');
                        $timeout(function() {
                            if (target === loginImgWrap) {
                                $scope.status.isShowDropdown = true;
                                return;
                            }
                            if (target !== loginImgWrap) {
                                $scope.status.isShowDropdown = false;
                            }
                        });      
                    });

                    /**
                     * [selectModule description] 选择模块
                     * @return {[type]} [description]
                     */
                    $scope.selectModule = function() {
                        $timeout(function() {
                            var routerName = angular.isDefined(iAttrs['myZoneUrl'])
                                ? iAttrs['myZoneUrl'] + '.personalinfo.info'
                                : 'front.myzone.personalinfo.info';
                            $state.go(routerName);
                            $scope.currModule = 'myZone';
                        });
                    };

                    /**
                     * [logout description] 退出登陆
                     *
                     * @return  {[type]}  [return description]
                     */
                    $scope.logout = function() {
                        globleParamsSet.clearStroge();
                        // 删除一个数据
                        // localStorage.removeItem('curUserInfo');
                        // 删除所有localStorage数据
                        localStorage.clear();
                        $('#unreadPrompt_js').hide(); // 关闭传稿提示框
                        // $scope.checkLoginOutIframeSrc = $location.path().split("/")[0] + "/wcm/logout.jsp";
                        $.ajax({
                            url: '/wcm/logout.jsp',
                            method: 'get',
                            async: false,
                            success: function() {},
                            error: function() {
                                // modalDialog.alertType('退出异常！',"", "warning", false);
                            },
                        });
                        $state.go('front', {}, { reload: true });
                    };

                    /**
                     * [getCurrentLoginUser description]获取当前用户
                     * @return {[type]} [description]
                     */
                    function getCurrentLoginUser() {
                        // var userInfo = localStorageService.get('curUserInfo'); // session改变
                        var userInfo = $sessionStorage.get('curUserInfo');
                        if (userInfo) {
                            $scope.user = userInfo.TRUENAME || userInfo.USERNAME;
                        } else {
                            var userParams = {
                                serviceid: 'mlf_extuser',
                                methodname: 'findUserInfo',
                            };
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, 'post').then(function(data) {
                                $scope.user = data[0].TRUENAME || data[0].USERNAME;
                            });
                        }
                    }
                    $scope.loginUserGroup = function() {
                        $scope.isPopoverShow = true;
                    };
                    $scope.loginUserLeave = function() {
                        $scope.isPopoverShow = false;
                    };

                    /**
                     * [userGroup description]
                     * @param   {[type]}  item  [item description]
                     * @return  {[type]}        [return description]
                     */
                    $scope.userGroup = function(item) {
                        var params = {
                            serviceid: 'mlf_extuser',
                            methodname: 'initGroupForLoginUser',
                            GroupId: item.GROUPID || item.GroupId,
                            GroupPath: item.GROUPPATH,
                        };
                        if ($scope.status.curGroupId !== item.GROUPID) {
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                                if (data.replace(/\"/g, '') === 'true') {
                                    // var userData = localStorageService.get('mlfCachedUser'); // session改变
                                    var userData = $sessionStorage.get('mlfCachedUser');
                                    userData.GroupId = item.GROUPID;
                                    // localStorageService.set('mlfCachedUser', userData); // session 改变
                                    $sessionStorage.set('mlfCachedUser', userData);
                                    $scope.$root.curUserGroup = userData;
                                    $state.go('front.editctr.iWo.personalManuscript', '', {
                                        reload: true,
                                    });
                                }
                            });
                        }
                    };
                });
            },
        };
    },
]);
